<template>
  <v-container>
    <!-- <v-banner> -->
    <v-card color="primary" width="400px" dark>
      <v-alert type="info" dismissible dense>
        <v-btn color="primary" rounded @click="dialog = true" small>
          How? Go to help
          <v-icon small right>fa-question-circle</v-icon>
        </v-btn>
      </v-alert>
      <v-form v-model="isValid">
        <v-row justify="center">
          <div :class="`d-flex justify-center`">
            <v-col>
              <v-btn
                name="button"
                @click="addMarker"
                color="primary"
                :disabled="mymarker.visible"
                rounded
                :class="`d-flex justify-space-around mb-6`"
                >Add position</v-btn
              >
            </v-col>

            <v-col>
              <div v-if="mymarker.visible">
                <v-btn color="primary" rounded @click="removeMyMarker()" small>
                  <v-icon small>fa-trash</v-icon>
                </v-btn>
              </div>
            </v-col>
          </div>
        </v-row>

        <div v-if="mymarker.visible">
          <v-row justify="center">
            <div :class="`d-flex justify-center`">
              <div v-if="!loggedIn">
                <v-col>
                  <v-text-field
                    v-model="ac"
                    outlined
                    required
                    dense
                    prepend-inner-icon="mdi-lock-question"
                    placeholder="Access code"
                    :rules="acRules"
                    hint="Your access code"
                    :append-icon="eyevalue ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="() => (eyevalue = !eyevalue)"
                    :type="eyevalue ? 'password' : 'text'"
                  ></v-text-field>
                </v-col>
              </div>
              <div>
                <v-col>
                  <v-btn
                    :disabled="!isValid"
                    color="primary"
                    @click="submit"
                    rounded
                    :class="`d-flex justify-space-around mb-6`"
                    >Save position</v-btn
                  >
                </v-col>
              </div>
            </div>
          </v-row>
          <v-alert type="success" :value="isAlertVisible">
            {{ statusResultMsg }}
            <v-btn to="/airbox/0" color="primary">OK</v-btn>
          </v-alert>
          <v-alert type="error" :value="isWarningAlertVisible">{{
            statusResultMsg
          }}</v-alert>
          <v-expansion-panels :light="true" focusable dense>
            <!-- <v-expansion-panel v-for="(item,i) in 1" :key="i"> -->
            <v-expansion-panel>
              <v-expansion-panel-header>Details</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-text-field
                  outlined
                  dense
                  prepend-inner-icon="mdi-location-on"
                  :value="mymarker.tooltip"
                  readonly
                ></v-text-field>
                <v-text-field
                  outlined
                  dense
                  prepend-inner-icon="mdi-location-on"
                  :value="mymarker.position.lat"
                  readonly
                  label="Latitude"
                ></v-text-field>
                <v-text-field
                  outlined
                  dense
                  prepend-inner-icon="mdi-location-on"
                  :value="mymarker.position.lng"
                  readonly
                  label="Longitude"
                ></v-text-field>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-form>
    </v-card>

    <ul v-if="errors && errors.length">
      <li v-for="error of errors" :key="error.id" style="color: Red">
        {{ error.message }}
      </li>
    </ul>
    <v-img height="100%" width="100%">
      <l-map
        :zoom.sync="zoom"
        :options="mapOptions"
        :center="center"
        :min-zoom="minZoom"
        :max-zoom="maxZoom"
        @update:center="centerUpdate"
        style="height: 500px; width: 100%; z-index: 0"
      >
        <l-control-layers
          :position="layersPosition"
          :collapsed="true"
          :sort-layers="true"
        />
        <l-tile-layer
          v-for="tileProvider in tileProviders"
          :key="tileProvider.name"
          :name="tileProvider.name"
          :visible="tileProvider.visible"
          :url="tileProvider.url"
          :attribution="tileProvider.attribution"
          :token="token"
          layer-type="base"
        />
        <l-control-zoom :position="zoomPosition" />
        <v-locatecontrol />
        <l-control-attribution
          :position="attributionPosition"
          :prefix="attributionPrefix"
        />
        <l-control-scale :imperial="imperial" />
        <l-marker
          :visible="mymarker.visible"
          :draggable="mymarker.draggable"
          :lat-lng.sync="mymarker.position"
          :icon="mymarker.icon"
        >
          <l-popup :content="mymarker.tooltip" />
          <l-tooltip :content="mymarker.tooltip" />
        </l-marker>
        <l-layer-group
          v-for="item in stuff"
          :key="item.id"
          :visible.sync="item.visible"
          layer-type="overlay"
          name="Other pilots"
        >
          <l-layer-group :visible="item.markersVisible">
            <l-circle-marker
              v-for="marker in markers"
              :key="marker.id"
              :lat-lng="marker.center"
              :radius="marker.radius"
              :color="marker.color"
            >
              <l-popup :content="marker.tooltip" />
              <l-tooltip :content="marker.tooltip" />
            </l-circle-marker>
          </l-layer-group>
        </l-layer-group>
      </l-map>
    </v-img>

    <v-row justify="center">
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>How to add position</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <AddPositionHelp></AddPositionHelp>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import { latLngBounds } from "leaflet";
import { latLng } from "leaflet";
// import Vue2LeafletLocatecontrol from 'vue2-leaflet-locatecontrol';
import Vue2LeafletLocatecontrol from "vue2-leaflet-locatecontrol/Vue2LeafletLocatecontrol";
import {
  LMap,
  LTileLayer,
  LMarker,
  //   LPolyline,
  LLayerGroup,
  LTooltip,
  LPopup,
  LControlZoom,
  LControlAttribution,
  LControlScale,
  LControlLayers,
  LCircleMarker,
} from "vue2-leaflet";
import AddPositionHelp from "@/components/help/AddPositionHelp.vue";

const markers1 = [
  //   {
  //     position: { lng: -1.219482, lat: 47.41322 },
  //     visible: true,
  //     draggable: true
  //   },
  //   { position: { lng: -1.571045, lat: 47.457809 } },
  //   { position: { lng: -1.560059, lat: 47.739323 } },
];

const poly1 = [
  //   { lng: -1.219482, lat: 47.41322 },
  //   { lng: -1.571045, lat: 47.457809 },
  //   { lng: -1.560059, lat: 47.739323 },
  //   { lng: -1.219482, lat: 47.41322 }
];

const tileProviders = [
  {
    name: "OpenStreetMap",
    visible: false,
    attribution:
      '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
  },
  {
    name: "OpenTopoMap",
    visible: true,
    url: "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png",
    attribution:
      'Map data: &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
  },
];

export default {
  name: "Example",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    // LPolyline,
    LLayerGroup,
    LTooltip,
    LPopup,
    LControlZoom,
    LControlAttribution,
    LControlScale,
    LControlLayers,
    LCircleMarker,
    "v-locatecontrol": Vue2LeafletLocatecontrol,
    AddPositionHelp,
  },
  data() {
    return {
      //   initialLocation: [59.93428, 30.335098],
      dialog: false,
      pid: Number,
      eventid: Number,
      statusResult: Number,
      statusResultMsg: String,
      loggedIn: false,
      cookieRegId: Number,
      cookieToken: Number,
      cancellink: { to: "/airbox/0" },
      isValid: true,
      isAlertVisible: false,
      isWarningAlertVisible: false,
      disableSaveBtn: false,
      v0: true,
      acRules: [(v) => !!v || "Access code is required"],
      ac: null,
      eyevalue: true,
      keys: ["position", "tooltip"],
      center: [59.504, 9.9969],
      currentCenter: latLng(59.504, 9.9969),
      opacity: 0.6,
      token: "your token if using mapbox",
      mapOptions: {
        zoomControl: false,
        attributionControl: false,
        zoomSnap: true,
      },
      zoom: 12,
      minZoom: 1,
      maxZoom: 20,
      zoomPosition: "topleft",
      attributionPosition: "bottomright",
      layersPosition: "topright",
      attributionPrefix: "Vue2Leaflet",
      imperial: false,
      Positions: ["topleft", "topright", "bottomleft", "bottomright"],
      tileProviders: tileProviders,
      pilotpositions: [],
      errors: [],
      mymarker: [],
      markers: [
        {
          id: "m1",
          //   position: { lat: 59.504, lng: 9.9969 },
          tooltip: "Grøtterud",
          //   draggable: false,
          //   visible: true,
          center: { lat: 59.504, lng: 9.9969 },
          //   center: [59.504, 9.9969],
          radius: 6,
          color: "red",
        },

        // {
        //   id: "m2",
        //   position: { lat: 51.8905, lng: -0.09 },
        //   tooltip: "tooltip for marker2",
        //   draggable: true,
        //   visible: false
        // },
        // {
        //   id: "m3",
        //   position: { lat: 51.005, lng: -0.09 },
        //   tooltip: "tooltip for marker3",
        //   draggable: true,
        //   visible: true
        // },
        // {
        //   id: "m4",
        //   position: { lat: 50.7605, lng: -0.09 },
        //   tooltip: "tooltip for marker4",
        //   draggable: true,
        //   visible: false
        // }
      ],
      polylines: [
        {
          id: "p1",
          points: [
            { lat: 37.772, lng: -122.214 },
            { lat: 21.291, lng: -157.821 },
            { lat: -18.142, lng: -181.569 },
            { lat: -27.467, lng: -206.973 },
          ],
          visible: true,
        },
        {
          id: "p2",
          points: [
            [-73.91, 40.78],
            [-87.62, 41.83],
            [-96.72, 32.76],
          ],
          visible: true,
        },
      ],
      stuff: [
        {
          id: "s1",
          markers: markers1,
          polyline: { points: poly1, visible: true },
          visible: true,
          markersVisible: true,
        },
      ],
      //   bounds: latLngBounds(
      //     { lat: 51.476483373501964, lng: -0.14668464136775586 },
      //     { lat: 51.52948330894063, lng: -0.019140238291583955 }
      //   )
    };
  },
  methods: {
    alert(item) {
      alert("this is " + JSON.stringify(item));
    },
    addMarker: function () {
      var clat = this.currentCenter.lat;
      var clng = this.currentCenter.lng;
      console.log(clat + "/" + clng);
      const newMarker = {
        // position = this.currentCenter,
        position: { lat: clat, lng: clng },
        draggable: true,
        visible: true,
        tooltip: "You",
      };
      //   this.markers.push(newMarker);
      this.mymarker = newMarker;
    },
    removeMarker: function (index) {
      this.markers.splice(index, 1);
      this.isAlertVisible = false;
      this.isWarningAlertVisible = false;
    },
    removeAllMarkers() {
      var array = this.markers;
      array.forEach((element) => {
        element.tooltip = "";
        this.markers.pop();
      });
    },
    removeMyMarker: function () {
      this.mymarker.tooltip = "";
      this.mymarker.position = { lat: 0, lng: 0 };
      this.mymarker.visible = false;
    },
    fitPolyline: function () {
      const bounds = latLngBounds(markers1.map((o) => o.position));
      this.bounds = bounds;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    helpMe() {
      alert("Sorry, no help implemented yet! :)");
    },
    submit() {
      var regId = this.pid;
      var ac = this.ac;
      var lat = this.mymarker.position.lat;
      var lon = this.mymarker.position.lng;
      var comment = this.comment;
      if (comment === null) {
        comment = "";
      }
      var toSubmit = JSON.stringify({ regId, ac, lat, lon, comment });
      const uri = this.baseUrl + "setpilotposition/" + regId;
      //   console.log(uri)
      console.log("toSubmit:", toSubmit);
      this.sendpost(uri, toSubmit, 1);
    },
    sendpost(uri, toSubmit, type) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      };
      axios
        .post(uri, toSubmit, axiosConfig)
        .then((response) => {
          if (type === 0) {
            this.statusResult = response.data.Result;
            this.statusResultMsg = response.data.ResultMsg;
          } else {
            this.statusResult = response.data[0].Result;
            this.statusResultMsg = response.data[0].ResultMsg;
          }
          if (this.statusResult == 1) {
            this.isValid = false;
            this.removeAllMarkers();
            this.getpositions();
          }
          this.setAlert(this.statusResult);
          //   if (this.statusResult === 1) {
          //       getstatus();
          //   }
        })
        .catch((e) => {
          this.errors.push(e);
          this.statusResult = 0;
          this.statusResultMsg = "Something went wrong!";
          this.setAlert(this.statusResult);
        });
    },
    setAlert(statusResult) {
      if (statusResult === 1) {
        this.isAlertVisible = true;
        this.isWarningAlertVisible = false;
      }
      if (statusResult === 0) {
        this.isWarningAlertVisible = true;
        this.isAlertVisible = false;
      }
    },
    getCookies() {
      this.cookieRegId = this.$cookies.get("pgbregid");
      this.cookieToken = this.$cookies.get("pgbtoken");
      this.pid = this.cookieRegId; //OBS: Bruker vanligvis regid her.
      this.ac = this.cookieToken;
      if (this.cookieToken > 0) {
        this.loggedIn = true;
      }
    },
    getpositions() {
      axios
        // .get("http://jsonplaceholder.typicode.com/posts")
        // .get('http://localhost:3000/pilotlist')
        .get(this.baseUrl + "getpositions/" + this.eventid)
        .then((response) => {
          // JSON responses are automatically parsed.
          this.pilotpositions = response.data;
          this.center = {
            lat: this.pilotpositions[0].lat,
            lng: this.pilotpositions[0].lon,
          };
          // console.log(this.pilotpositions);
          var array = this.pilotpositions;
          array.forEach((element) => {
            const newCircleMarker = {
              id: element.id,
              tooltip: element.tooltip + "</br>" + element.MID,
              center: { lat: element.lat, lng: element.lon },
              radius: element.radius,
              color: element.color,
              visible: true,
            };
            this.markers.push(newCircleMarker);
          });
          console.log(this.markers);
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
  },
  created() {
    this.baseUrl = "https://pgapi.azurewebsites.net/dbapi/";
    // this.baseUrl = "http://localhost:3000/dbapi/";
    // this.pid = 1;
    this.pid = this.$route.params.id;
    this.eventid = this.$route.params.eventid;
    if (this.pid === undefined) {
      this.pid = 0;
      // this.showessentials = false;
    }
    this.mymarker.tooltip = "";
    this.mymarker.position = { lat: 0, lng: 0 };
    this.mymarker.visible = false;
    this.getpositions();
    this.getCookies();
  },
  //   mounted() {
  //     this.$nextTick(() => {
  //       this.$refs.myMap.mapObject.ANY_LEAFLET_MAP_METHOD();
  //     });
  //   }
};
</script>

<style>
/* @import "~leaflet/dist/leaflet.css"; */
/* @import "https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"; */
/* html,
body {
  height: 100%;
  margin: 0;
} */
</style>